import React from 'react';
import Spin from 'antd/es/spin';

import { CourseInformation } from 'components/course-information';
import { TwoColumnLayout } from 'components/layout/two-column-layout';
import { MiddleContainer } from 'components/suspense/global-suspense/elements';

export const BookingSuspense = () => (
  <TwoColumnLayout
    firstColumn={
      <CourseInformation />
    }
    secondColumn={
      <MiddleContainer>
        <Spin size="large" />
      </MiddleContainer>
    }
  />
);
